import React from "react";
import { Link } from "react-router-dom";
import "./ShopByAge.css";
export default function ShopByAge() {
  return (
    <section className="shop-by-age">
      <div className="container">
        <h2>Shop By Age/Size</h2>
        <div className="age-scroll-container">
          <div className="age-grid">
            <Link
              state={{ sizes: ["0-0.3", "0.3-0.6"], filterBySize: true }}
              to="/products/0-6M"
              className="age-item"
            >
              <div className="age-item-image">
                <img src="images/shopbyage/NEWBORN.png" alt="Newborn" />
              </div>
              <div className="age-item-content">
                <h3>Newborn</h3>
                <p className="age-item-subtitle">0-6 MONTHS</p>
              </div>
            </Link>

            <Link
              state={{ sizes: ["0.6 - 1", "1-2"], filterBySize: true }}
              to="/products/6-24-months"
              className="age-item"
            >
              <div className="age-item-image">
                <img src="images/shopbyage/TODDLER.png" alt="Infant" />
              </div>
              <div className="age-item-content">
                <h3>Infant</h3>
                <p className="age-item-subtitle">6-24 MONTHS</p>
              </div>
            </Link>

            <Link
              state={{
                sizes: ["2-3", "3-4", "4-5", "5-6", "6-7"],
                filterBySize: true,
              }}
              to="/products/4-7-years"
              className="age-item"
            >
              <div className="age-item-image">
                <img src="images/shopbyage/INFANT.png" alt="Toddler" />
              </div>
              <div className="age-item-content">
                <h3>Toddler</h3>
                <p className="age-item-subtitle">2-7 Years</p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
